import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import { cn } from "@tine/designsystem-utils";
import { type ArticleProps, prefaceFont } from "./Article";

const SimpleArticleHero = ({ article, id }: ArticleProps) => {
   const inspectorProps = useContentfulInspectorMode();

   return (
      <>
         <h1
            className="mt-2 mb-6"
            {...inspectorProps({
               entryId: id,
               fieldId: "title"
            })}
         >
            {article.fields.title}
         </h1>

         {article.fields.preface && (
            <p
               className={cn(prefaceFont, "mb-6 font-normal")}
               {...inspectorProps({
                  entryId: id,
                  fieldId: "preface"
               })}
            >
               {article.fields.preface}
            </p>
         )}
      </>
   );
};

export default SimpleArticleHero;
